export default {
  form: {
    font_family: {
      label: 'Famiglia font',
    },
    header: {
      label: 'Intestazione',
      placeholder: 'Intestazione',
    },
    sub_header: {
      label: 'Sottotitolo',
      placeholder: 'Sottotitolo',
    },
    qr_code_header: {
      label: 'Intestazione riquadro',
      placeholder: 'Intestazione riquadro',
    },
    qr_code_description: {
      label: 'Descrizione riquadro',
      placeholder: 'Descrizione riquadro',
    },
    footer: {
      label: 'Testo piè di pagina',
      placeholder: 'Inserisci testo piè di pagina',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleziona URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Colore primario',
    },
    background_color: {
      label: 'Colore di sfondo',
    },
    cover_image: {
      label: 'Immagine di copertina',
    },
    logo: {
      label: 'Logo',
    },
    logo_zoom: {
      label: 'Zoom logo',
    },
  },
  toasts: {
    failed_to_load_data: "Impossibile caricare l'adesivo",
  },
};
